import { render, staticRenderFns } from "./CustomViews.vue?vue&type=template&id=ac84bb18&scoped=true&"
import script from "./CustomViews.vue?vue&type=script&lang=js&"
export * from "./CustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac84bb18",
  null
  
)

export default component.exports